import { useContext, useState } from "react";
import VspPortalContext from "../../store/VspPortalContext";
import { NotificationTypes } from "../../enums/NotificationTypes";
import { CardholderCompetencyDto } from "../../dtos/CardholderCompetencyDto";
import { HttpMethods } from "../../enums/HttpMethods";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";



export type CardholderCompetencyResponse = {

    cardholderCompetencyDto: CardholderCompetencyDto | null;
    statusCode: number | null;

};


export const useManageCompetencyHttp = ( ): {
    
    addCardholderCompetency ( competency: string, employeeId: string, expiry: string | undefined, villageName: string ): Promise<boolean>
    , getCardholderCompetency( competency: string, employeeId: string, villageCode: string ): Promise<CardholderCompetencyResponse>
    , removeCardholderCompetency( competency: string, employeeId: string, villageCode: string ): Promise<boolean>

} => {

    const { dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );

    const addCardholderCompetency = async( competency: string, employeeId: string, expiry: string | undefined, villageCode: string ): Promise<boolean> => {

        // const formattedExpiry = expiry + "T15:59:59Z";

        const requestBody = [
            {
              "op": "add",
              "path": "competency",
              "value": 
              {
                "competency": competency,
                "expiry": expiry === undefined ? null : expiry //formattedExpiry
              }
            }
        ];
        
        
        const options = await getHttpOptions ( HttpMethods.Patch, JSON.stringify( requestBody ) );
        const query = `${process.env.REACT_APP_API_URL}/cardholderCompetency?employeeId=${employeeId}&villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error adding cardholder competency' });

            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Cardholder competency successfully added' });

        return true;

    };


    const getCardholderCompetency = async ( competency: string, employeeId: string, villageCode: string ): Promise<CardholderCompetencyResponse> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/cardholderCompetency?competency=${competency}&employeeId=${employeeId}&villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response.statusCode == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: `Error getting cardholder ${competency} competency for ${villageCode}` });

            return {

                cardholderCompetencyDto: null,
                statusCode: null

            };

        } 
        
        if ( response.statusCode === 200 ) {
        
            return {
                
                cardholderCompetencyDto: await response.response?.json( ),
                statusCode: 200

            }

        }

        return {

            cardholderCompetencyDto: null,
            statusCode: response.statusCode

        };

    };


    const removeCardholderCompetency = async ( competency: string, employeeId: string, villageCode: string ): Promise<boolean> => {

        const requestBody = [
            {
                op: "remove",
                path: "competency",
                value: 
                {
                    Competency: competency
                }
            }
        ];

        
        const options = await getHttpOptions ( HttpMethods.Patch, JSON.stringify( requestBody ) );
        const query = `${process.env.REACT_APP_API_URL}/cardholderCompetency?employeeId=${employeeId}&villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error removing cardholder competency' });

            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Cardholder competency successfully removed' });

        return true;

    };

    return { addCardholderCompetency, getCardholderCompetency, removeCardholderCompetency };

};
